import { atom } from 'infrastructure/state/jotai.wrapper'
import { SlidesPrepareResultData, SlidesProcessResultData } from './types'
import { googleUserAtom } from 'infrastructure/googleDrive'

export const prepareResultAtom = atom<SlidesPrepareResultData | null>(null)
export const processResultAtom = atom<SlidesProcessResultData | null>(null)
export const selectedLessonIdsAtom = atom<Set<string>>(new Set<string>())

export const canStartPrepareAtom = atom((get) => {
  const googleUser = get(googleUserAtom)
  return Boolean(googleUser?.credential?.accessToken)
})

export const canStartProcessAtom = atom((get) => {
  const prepareResult = get(prepareResultAtom)
  const selectedIds = get(selectedLessonIdsAtom)
  return prepareResult !== null && selectedIds.size > 0
})

export const isPipelineCompleteAtom = atom((get) => {
  return get(processResultAtom) !== null
})

/** Debug only: override Google auth (e.g. access token). Not used for processing. */
export const googleAuthOverrideAtom = atom<string | null>(null)
